import React from 'react'
import TopBar from '../bars/top-bar'
import BackIconButton from '../buttons/BackIconButton'
import HeadingBeta from '../headings/heading-beta'
import InfoBlock from '../texts/info-block'

const createTopBarLeftChildren = props => {
  const topBarLeftChildren = [<BackIconButton key='BackIconButton' />]
  return topBarLeftChildren
}

const Contact = props => {
  return (
    <div className='detail-item inner-wrapper-wide'>
      <TopBar
        theme='light-bar'
        leftChildren={createTopBarLeftChildren(props)}
      />
      <HeadingBeta className='bottom-space'>Contact Information</HeadingBeta>
      <InfoBlock>
        <p>CHAIR-BIDS LLC</p>
        <p>505 S. Flagler Drive, Suite 900</p>
        <p>West Palm Beach , Fl 33401</p>
        <a href='mailto:customersupport@chairbids.com'>
          customersupport@chairbids.com
        </a>
      </InfoBlock>
    </div>
  )
}

export default Contact



// WEBPACK FOOTER //
// ./src/ui/views/contact.js